export default "__VITE_ASSET__2Nqh0VNV__"